import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../../shared/shared.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UsagePaymentsService } from '../usage-payments.service';
import { MatDialog } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { DataSource } from '@angular/cdk/collections';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { DatePipe, TitleCasePipe } from '@angular/common';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/of';
declare var $: any;

@Component({
  selector: 'app-dpp-usage',
  templateUrl: './dpp-usage.component.html',
  styleUrls: ['./dpp-usage.component.css']
})
export class DppUsageComponent implements OnInit {
  displayedColumns = ['date', 'description', 'amount', 'balance'];
  public dateWiseStatTable: DateWiseStatTable;
  public is_more_detail: boolean;
  public person_detail: any;
  public account_no:number;
  public username: any;
  public street_address1: any;
  public street_address2: any;
  public customer_since: any;
  public esi_id: any;
  public user_id: any;
  public transactionSummary: Array<DateWiseStat>;
  public data_list: any;
  public is_monthly_stat: boolean;
  public is_loader: boolean;
  public is_error:boolean;
  public error_msg:string;

  constructor(public dialog: MatDialog, private activatedRoute: ActivatedRoute, private titlecasePipe:TitleCasePipe,
    private sharedService: SharedService, private localStorageService: LocalStorageService,
    private router: Router, private usagePaymentsService: UsagePaymentsService) {
  		this.sharedService.setHeaderTitleDynamicVal('dpp_usage_payments', 'DPP History', '');
  		if (this.localStorageService.get('token') != null) {
  			this.is_more_detail = true;
	        this.data_list = [];
	        this.is_monthly_stat = false;
	        this.is_loader = true;
          this.is_error = false;
          this.error_msg = "";
	        this.sharedService.verifyToken({'token' : this.localStorageService.get('token')})
		        .then(res => {
              console.log("TOKEN CONFIRM", res);
		            this.sharedService.setHeaderTitle('default_page');
		            if (res.status === 'success' && res.isTerminated === false) {
		              	if (!res.isEnrolled) {
		                	this.router.navigate(['./dashboard']);
		              	} else {
                      const person = res.results[0]['personal'][0];
			                this.user_id = person['id'];
                      this.username = person.firstName + ' ' + person.lastName;
                      this.username = this.titlecasePipe.transform(this.username);
			                this.street_address1 = person.billingAddress;
			                this.street_address2 = person.city  + ', ' + person.state + ' '  + person.zipCode;
			                this.account_no = person.accountNumber;
                      const service = res.results[0]['service'][0];

                      // Used for dataLayer.push
                      const dataLayerAccountInfo = res.results[0]['personal'];

                      (window as any).dataLayer.push({ 'event': 'DPP Usage', 'accountID': dataLayerAccountInfo[0].id.toString(), 'accountNumber': dataLayerAccountInfo[0].accountNumber.toString() });

                      if (service){
                        this.customer_since = service.serviceStartDate;
                        this.esi_id = service.esiId;
                      }

			                const that = this.sharedService;
			                setTimeout(function(){
			                  that.setHeaderErrorMessage('dpp_usage_payments', false, 'notification error', '');
			                  that.setHeaderUserLoggedIn('dpp_usage_payments', true, person);
			                }, 10);

			                this.usagePaymentsService.getDPPUsageAndPayments({'token' : this.localStorageService.get('token')})
				                .then(res1 => {
                          console.log("RES1 DPP", res1);
				                  this.is_loader = false;
				                  if  (res1["status"] === 'success') {
				                    this.transactionSummary = this.getTransactionSummary(res1["transactionSummary"]);
				                    this.dateWiseStatTable = new DateWiseStatTable(this.transactionSummary);
				                  } else {
                            this.is_error = true;
                            this.error_msg = res1.message;
                          }
				                });
		              	}
				    } else {
				        this.localStorageService.remove('token');
				        this.router.navigate(['./sign-in']);
				    }
				});
  		}
    }

  ngOnInit() {
  }

  getTransactionSummary(summary:any[]){
  	let transactionSummary:Array<DateWiseStat> = [];
  	for (var i = 0; i < summary.length; i++) {
  		let trans = summary[i];
  		let transSumm = {
        id: trans.accountTransactionID,
  			date: new DatePipe('en-US').transform(trans.bill_date, 'yyyy-MM-dd'),
  			description: trans.description.split(";"),
  			amount: trans.transactionAmt,
  			balance: trans.dailyDPPBalanceAmt
  		};
  		transactionSummary.push(transSumm);
  	}
  	return transactionSummary
  }

  expandCollapseDetail(date: any, op: any) {
    if  (op === 'expand') {
	    $('.desc-' + this.replaceDate(date)).fadeIn('500');
	    $('.collapse-' + this.replaceDate(date)).show();
	    $('.expand-' + this.replaceDate(date)).hide();
    } else if (op === 'collapse') {
	    $('.desc-' + this.replaceDate(date)).fadeOut('500');
	    $('.expand-' + this.replaceDate(date)).show();
	    $('.collapse-' + this.replaceDate(date)).hide();
    }
  }

  expandCollapse(id: number, op: any) {
    if  (op === 'expand') {
      $('.desc-' + id.toString().trim()).fadeIn('500');
      $('.collapse-' + id.toString().trim()).show();
      $('.expand-' + id.toString().trim()).hide();
    } else if (op === 'collapse') {
      $('.desc-' + id.toString().trim()).fadeOut('500');
      $('.expand-' + id.toString().trim()).show();
      $('.collapse-' + id.toString().trim()).hide();
    }
  }

  replaceDate(date) {
    const re = /\//gi;
    return date.replace(re, '-');
  }

  changeMoreOrLess(is_more: boolean) {
    this.is_more_detail = is_more;
  }

}

export interface DateWiseStat {
    id: number;
    date: string;
    description: string[];
    amount: number;
    balance: number;
}

export class DateWiseStatTable extends DataSource<any> {
    public data: DateWiseStat[];
    constructor(private elementData: DateWiseStat[]) {
      super();
      this.data = this.elementData;
    }
    connect(): Observable<DateWiseStat[]> {
        return Observable.of(this.data);
    }
    disconnect() {}
}



// WEBPACK FOOTER //
// ./src/app/payment/usage-payments/dpp-usage/dpp-usage.component.ts